import { authFetch } from '../AuthFetch';
import { createAction } from 'redux-actions';


export const forwardToCompleteAudit = (card, type, auditor) => (
    (dispatch) => {
        let cardRequest = {
            cardId: card.id,
            type: type,
            auditor: auditor,
        };

        let url = '/maintenance/cards/i' + card.id + '/type/' + type + '/audit';
        authFetch('POST', url, JSON.stringify(cardRequest), (json) => {
            dispatch({
                type: 'FIND_AUDITABLE_MAINTENANCE_DETAILS',
                payload: json
            });
        });
    }
);

export const forwardToAuditDetail = (detail, card, type, auditor) => (
    (dispatch) => {
        let cardRequest = {
            cardId: card.id,
            detailId: detail.id,
            type: type,
            auditor: auditor,
        };

        let url = '/maintenance/cards/i' + card.id + '/details/i' + detail.id + '/audit';
        authFetch('POST', url, JSON.stringify(cardRequest), (json) => {
            dispatch({
                type: 'FIND_AUDITABLE_MAINTENANCE_DETAILS',
                payload: json
            });
        });
    }
);

export const forwardToRefixDetail = (detail, card, type) => (
    (dispatch) => {
        let cardRequest = {
            cardId: card.id,
            detailId: detail.id,
            type: type,
        };

        let url = '/maintenance/cards/i' + card.id + '/details/i' + detail.id + '/rework';
        authFetch('POST', url, JSON.stringify(cardRequest), (json) => {
            dispatch({
                type: 'FIND_AUDITABLE_MAINTENANCE_DETAILS',
                payload: json
            });
        });
    }
);


export const forwardToFindAuditableDetails = (cardPk, type) => (
    (dispatch) => {
        let cardRequest = {
            cardId: cardPk,
            type: type
        };
        let url = '/maintenance/cards/i' + cardPk + '/details/' + type + '/auditable';
        authFetch('POST', url, JSON.stringify(cardRequest), (json) => {
            dispatch({
                type: 'FIND_AUDITABLE_MAINTENANCE_DETAILS',
                payload: json
            });
        });
    }
);


export const forwardToAssignAuditingCardTarget = (editing) => (
    (dispatch) => {
        dispatch({
            type: "ASSIGN_AUDITING_MCARD_TARGET",
            payload: editing
        });
    }
);


export const forwardToAssignAuditingTarget = (mcase) => (
    (dispatch) => {
        dispatch({
            type: "ASSIGN_AUDITING_MCASE_TARGET",
            payload: mcase
        });
    }
);

export const forwardToFindAuditableMCases = (id) => (
    (dispatch) => {
        let url = '/maintenance/mcases/status';
        let request = { criteriaStatus: ['FIXED', 'FIXING'] };
        authFetch('POST', url, JSON.stringify(request), (json) => {
            dispatch({
                type: "FIND_AUDITABLE_MCASES",
                payload: json
            });
        });
    }
);

export const forwardToFindAuditableMCards = (id) => (
    (dispatch) => {
        let cardRequest = {
            casePk: id,
            cardStatuss: ['AUDITED', 'FIXED', 'FIXING']
        };
        let url = '/maintenance/mcases/i' + id + '/cards/status';
        authFetch('POST', url, JSON.stringify(cardRequest), (json) => {
            dispatch({
                type: 'FIND_AUDITABLE_MAINTENANCE_CARDS',
                payload: json
            });
        });
    }
);

export const forwardToSortAuditableMaintenanceCards = (cards, order) => {
    let asc = order.get('asc') == undefined ? true : order.get('asc');
    let by = order.get('by');
    let clone = [];
    cards.map((item, index) => {
        clone.push(item);
    });

    switch (by) {
        case "code":
            clone.sort((a, b) => {
                let comparison = asc ? (a.code < b.code) : (a.code > b.code);
                return comparison ? 1 : -1;
            });
            break;
        case "status":
            clone.sort((a, b) => {
                let comparison = asc ? (a.status < b.status) : (a.status > b.status);
                return comparison ? 1 : -1;
            });
            break;
        case "owner":
            clone.sort((a, b) => {
                let comparison = asc ? (a.owner < b.owner) : (a.owner > b.owner);
                return comparison ? 1 : -1;
            });
            break;
        case "unit":
            clone.sort((a, b) => {
                let comparison = asc ? (a.unit < b.unit) : (a.unit > b.unit);
                return comparison ? 1 : -1;
            });
            break;
    }

    let ret = (dispatch) => {
        dispatch(
            {
                type: 'FIND_SORTED_AUDITABLE_MAINTENANCE_CARDS',
                payload: { cards: clone, order: order },
            }
        )
    }

    return ret;
}

export const forwardToMarkPostQueue = () => (
    (dispatch) => {
        dispatch({
            type: 'MARK_QUEUE_POST_PHOTO',
            payload: null,
        });
    }
);

export const forwardToMarkPostPop = () => (
    (dispatch) => {
        dispatch({
            type: 'MARK_POP_POST_PHOTO',
            payload: null,
        });
    }
);

export const forwardToUploadPostPhoto = (dataUri, card, type, stage, operator) => (
    (dispatch) => {
        let url = "/maintenance/photos/cards/i" + card.id + "/type/" + type + "/takepost";
        let request = {
            cardId: card.id,
            type: type,
            image: dataUri,
            stage: stage,
            operator: operator,
        };

        authFetch('POST', url, JSON.stringify(request), (json) => {
            dispatch({
                type: 'QUEUE_POST_PHOTO',
                payload: json,
            });
        });
    }
);

export const forwardToFindPostPhotos = (card, type, stage) => (
    (dispatch) => {
        let url = "/maintenance/photos/cards/i" + card.id + "/type/" + type + "/find";
        let request = {
            cardId: card.id,
            type: type,
            stage: stage,
        };

        authFetch('POST', url, JSON.stringify(request), (json) => {
            dispatch({
                type: 'QUEUE_POST_PHOTO',
                payload: json,
            });
        });
    }
);

export const cleanAuditingAlert = createAction('CLEAN_AUDITING_ALERT');


// 結尾加2為將「維修增補項目」改為「檢點增補項目」的程式
// copy from MaintenanceAppendModifyContainer 再調整
export const forwardToFindDetails2 = (card) => (    //這裏的card是card.id，先不動，找時間看能不能重構
    (dispatch) => {
        let cardRequest = {
            cardId: card,
        };
        // 後端和fixable call 同一個 url 即可
        let url = '/maintenance/cards/i' + card + '/details/fixable';
        authFetch('POST', url, JSON.stringify(cardRequest), (json) => {
            dispatch({
                type: 'FIND_AUDITABLE_MAINTENANCE_DETAILS',
                payload: json
            });
        });
    }
);

export const forwardToDeleteAppendDetail2 = (detail, card) => (
    (dispatch) => {
        let url = '/maintenance/cards/i' + card.id + '/details/i' + detail.id + '/delAppend';
        let request = {
            cardId: card.id,
            detailId: detail.id,
            refineStatus: detail.refineStatus
        };
        authFetch('POST', url, JSON.stringify(request), (json) => {
            dispatch({
                type: "FIND_AUDITABLE_MAINTENANCE_DETAILS",
                payload: json
            });
        });
    }
);

export const forwardToShowMaintenanceModifyComponentModal2 = (card, category) => (
    (dispatch) => {
        let payload = {
            card: card,
            category: category
        }
        dispatch({
            type: "SHOW_MAINTENANCE_MODIFY_COMPONENT_MODAL_2",
            payload: payload
        });
    }
);
  
export const forwardToHideMaintenanceModifyComponentModal2 = () => (
    (dispatch) => {
        dispatch({
            type: "HIDE_MAINTENANCE_MODIFY_COMPONENT_MODAL_2",
            payload: null,
        });
    }
);

export const forwardToAssignAppendCheckSet2 = (checkSet) => (
    (dispatch) => {
        dispatch({
            type: "ASSIGN_APPEND_CHECK_SET_2",
            payload: checkSet,
        });
    }
);

export const forwardToAssignAppendCheckItem2 = (checkItem) => (
    (dispatch) => {
        dispatch({
            type: "ASSIGN_APPEND_CHECK_ITEM_2",
            payload: checkItem,
        });
    }
);

export const forwardToAssignAppendCheckNote2 = (note) => (
    (dispatch) => {
        dispatch({
            type: "ASSIGN_APPEND_CHECK_NOTE_2",
            payload: note,
        });
    }
);

export const forwardToAppendMissingDamageCheckDetail2 = (editing) => (
    (dispatch) => {
        let sts = editing.refineStatus === "ESCAPE" ? "FIXED" : "CREATED";
        let maintenanceDetail = {
            maintenanceCardId: editing.cardPk,
            categoryId: editing.categoryPk,
            setId: editing.setPk,
            itemId: editing.itemPk,
            note: editing.note,
            epc: editing.epc,
            refineStatus: editing.refineStatus,
            status: sts,
            creator: editing.creator
        };
        let url = '/maintenance/details/append/' + editing.refineStatus;
        authFetch('POST', url, JSON.stringify(maintenanceDetail), (json) => {
            dispatch({
                type: 'FIND_FIXABLE_MAINTENANCE_DETAILS_2',
                payload: json
            });
        });

        dispatch({
            type: "HIDE_APPEND_DETAIL_MODAL_AND_CLEAR_2",
            payload: null
        });
    }
);

export const forwardChangeIsLoadingPage2 = createAction('LOADING_PAGE_2');


// WEBPACK FOOTER //
// ./src/actions/maintenanceAuditAction.js